import { render } from "./MakeCoverage.vue?vue&type=template&id=055c1c4f&ts=true"
import script from "./MakeCoverage.vue?vue&type=script&lang=ts"
export * from "./MakeCoverage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__